import React from 'react';
import UserManagement from '../UserManagement';
import BackOfficeLayout from '../../components/backoffice/BackOfficeLayout';

export default function BackOfficeUsers() {
  return <UserManagement LayoutComponent={BackOfficeLayout} />;
}
